export default __webpack_public_path__ + "static/media/ac_wew.b3c6f21b.bmp";